export const KANBAN_FORM = "configKanbanForm";